<form name="textEditorForm" class="bc-editor-form clearfix">
  <div class="bc-editor">
    <button
      #fileSelectButton
      ngfSelect
      accept="image/png, image/jpeg, image/gif"
      maxSize="{{ maxFileSize }}"
      type="button"
      class="editor-file-upload"
      (click)="selectedFile = null"
      [(file)]="selectedFile"
      (fileChange)="fileSelected.emit(selectedFile)"
      [disabled]="fileSelectionDisabled"
      title="{{ 'genesysEditor.imageUploadButtonTooltip' | translate }}"
      data-automation-id="gc-chat-file-upload-picker"
    ></button>

    <app-genesys-insert-image
      class="insert-image"
      *ngIf="showInsertImageDialog$ | async"
      (addImage)="insertImageLink($event)"
      (closeInsertImage)="toggleImageLinkDialog()"
    ></app-genesys-insert-image>

    <div class="bc-editor-text-container">
      <editor
        [ngModel]="editorContent"
        (ngModelChange)="handleInnerChange($event)"
        name="tinyMceEditor"
        [disabled]="editorDisabled"
        [attr.data-automation-id]="'gc-editor-instance'"
      ></editor>

      <div>
        <button
          type="button"
          class="btn js-quote-button quote-button"
          title="{{ 'genesysEditor.quoteButtonTooltip' | translate }}"
          *ngIf="showQuoteButton"
          (click)="quoteButtonClick.emit()"
          [attr.data-automation-id]="'gc-editor-quote-button'"
        >
          ...
        </button>
      </div>
    </div>
  </div>
</form>
